import { PaymentService } from '@app/_services/payment.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonUtility } from '@app/_modules/commonUtility';
import * as master from '../../assets/master.json';

import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { formatDate } from '@angular/common';

export interface masters {
  totalAmount:number;
 
}

@Component({ templateUrl: 'student-details.component.html' })
export class StudentDetailComponent implements OnInit {
    JSON;
  @ViewChild('txnForm') txnForm: any;
    isgPay_url:any;
    todayDate:Date;
    toDate:any;
    EncDataField:string;
    submitBtnMsg:String;
    submitBtnMsgClass:String = 'wrappper';
    MerchantIdField:string;
    TransactionId:string;
    BankIdField:string;
    TerminalIdField:string;
    VersionField:string;
    isRecordNotFound:boolean = false;
    form: FormGroup;
    tranxnForm : FormGroup;
    loading = false;
    submitted = false;
    registeras;
    totalAmount:any;
    monthDues:any;
    json:any= master;
    masterData:any;
    monthDuesList:any[]=[];
    monthDuesListObj:any[]=[];
    dataSource:any;
    masterJson:any;
    res:any;
    billDate:any='';
    feeData:any;
    dueDate:any;
    todayDate1:any;

    totalDisabled:boolean=true;
    studentData:any;
    commonUtility:CommonUtility;
    lateFee: number = 0;
    dailyIncrease: number = 10;
    lateFeeDate:any;
    split;
    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,

        private paymentService: PaymentService
    ) {
      this.JSON=JSON;
      this.masterData = master;
      this.isgPay_url = paymentService.isgPay_url;
      this.res=this.router.getCurrentNavigation().extras.state

      this.http.get('aei/assets/master.json').subscribe(data => {
        console.log(data);
        this.masterJson = data;
  });



      if(this.router.getCurrentNavigation().extras.state === null || this.router.getCurrentNavigation().extras.state === undefined)
      {
        this.router.navigate(['/payment/get-student']);
      }
     if(!(this.res.message === "No Payment Found"))
     {
      this.studentData = this.res.studentData;
      this.feeData = this.res.feeData;
   /*    this.billDate = this.res.billDate */
      this.dueDate = this.res.dueDate
      this.commonUtility = paymentService.commonUtility;
     }
     else
     {
      this.isRecordNotFound = true;
     }
    }

    ngOnInit() {
/*
      this.todayDate = new Date();
      console.log("this.todayDate ="+this.todayDate );
      this.todayDate1 = formatDate(this.todayDate,'dd-MM-yyyy','en-US');

      this.todayDate1 =  this.todayDate1.split('-');
      this.lateFeeDate = parseInt(this.todayDate1);
      console.log("this.lateFeeDate ="+this.lateFeeDate );

      const daysLate = this.lateFeeDate - 10;

      
      if(this.lateFeeDate > 10){

        console.log("in if"+JSON.stringify(this.lateFeeDate))
          this.lateFee = this.lateFee+ (this.dailyIncrease * daysLate);
      
         }
         else{
          console.log("in else"+JSON.stringify(this.lateFee))
  
          this.lateFee =0;
  
        }
*/

const todayDate: Date = new Date();
console.log("todayDate = " + todayDate);

const targetDate: Date = new Date(this.dueDate);
console.log("targetDate = " + targetDate);


const daysLate: number = Math.max(0, Math.floor((todayDate.getTime() - targetDate.getTime()) / (24 * 60 * 60 * 1000)));
console.log("daysLate = " + daysLate);


const dailyIncrease: number = 10;
let lateFee: number = 0;

if (daysLate > 0) {
  lateFee = dailyIncrease * daysLate;
}

this.lateFee =lateFee;
console.log("Late Fee = " + lateFee);

        this.registeras =1;
        this.form = this.formBuilder.group({
          month : ['', Validators.required],
          studentName : [''],
          monthDues : [''],
          messDues : [''],
          lateFee :[''],
          disability : ['', Validators.required],
          hostelNo : [''],
          totalAmount:[{value: '', disabled:true}]
        });
        this.tranxnForm = this.formBuilder.group({
          Version:[''],
          TerminalId: [''],
          BankId: [''],
          MerchantId: [''],
          EncData:[''],
          TransactionId:['']

               });
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }
    redirectHome()
    {
      window.location.reload();
      this.router.navigate(['/']);
    }
    onSubmit() {

      console.log("in submit")
        this.submitted = true;

        // reset alerts on submit
        // this.alertService.clear();
        // stop here if form is invalid
        if (this.form.invalid) {

          return;
        }
        localStorage.setItem('source',this.studentData.rollNo.split('-')[0]);

        console.log("this.studentData.rollNo.split('-')[0]"+JSON.stringify(this.studentData.rollNo.split('-')[0]));
        this.loading = true;

        var req={
            "month": this.form.controls.month.value.toString(),
            "monthDues": this.form.controls.monthDues.value.toString(),
            "rollNo":this.studentData.rollNo.toString(),
            "studentName":this.studentData.studentName.toString(),
            "hostelNo":this.studentData.hostelNo.toString(),
            "messDues" :  this.studentData.messDues.toString(),
            "parentName" :  this.studentData.parentName.toString(),
            "phoneNo" :  this.studentData.phoneNo.toString(),
            "disability": this.form.controls.disability.value.toString(),
            'lateFee':this.lateFee,
            "totalAmount": this.totalAmount.toString(),
            "status" : this.studentData.status.toString(),
            "source" : "AEI"
        }
        debugger;
        this.paymentService.submitAasamDetails(req).subscribe(res=>{


       if(res.body.statusCode === "00000")
       {
        //console.log(" res : "+JSON.stringify(res))
        //this.commonUtility.alertMsg('Submitted Successfully ','',true);
        this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
        this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
        this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
        this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
        this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
        this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);

        this.EncDataField  	= res.body.data.fields.EncData;
        this.MerchantIdField = res.body.data.fields.MerchantId;
        this.BankIdField = res.body.data.fields.BankId;
        this.TerminalIdField = res.body.data.fields.TerminalId ;
        this.VersionField = res.body.data.fields.Version ;
        this.txnForm.nativeElement.submit();


       }
       else{
        this.commonUtility.alertMsg('Please try again Failed to submit data'+res.body.statusDesc,'',false);
       }
        this.loading = false;
      },
      (error)=>{

        this.commonUtility.alertMsg('Please try again Failed to submit data','',false);
          //this.router.navigate([''])
          this.loading = false;
        });

    }

     showForm (ele){
        this.registeras =ele;
    }
    checkZero(value)
    {
      var a:number=Number(value);

      if(Number.isNaN(a) || a == null || a === Number(0) || a === undefined || value === null || value === undefined)
      {
        return false;
      }
      return true;
    }

    onMonthChange(event)
    {
      var monthDuesListData =[];

      var monthObj;
      var monthDuesListObj:any;
      console.log("this.masterJson"+JSON.stringify(this.masterJson));
     
      this.masterJson;
      var selectedMonth =  this.form.controls.month.value.toString()
    this.form.controls.monthDues.setValue('');

     var value = 0;
     event.value.map(item=>{
      console.log(item);
      this.masterJson.monthDuesList.forEach(function (monthDuesData){

        console.log(" monthDuesData ");            
        console.log(monthDuesData);
        console.log(monthDuesData.month == selectedMonth);
       
       
       if(monthDuesData.month == item){
          value =  value + parseInt(monthDuesData.monthDues)

        }
      });
    })



     this.form.controls.monthDues.setValue(value);
         

     this.form.updateValueAndValidity()

     this.form.controls.monthDues.updateValueAndValidity();

    this.getTotal();

   

    }
              
    

    getTotal()
    
    {

      

      this.totalAmount
      let monthDues =  this.form.controls.monthDues.value;
      let messDues = this.studentData.messDues;
      


      this.totalAmount =0;
      if(monthDues)
      {
        this.totalAmount = Number(this.totalAmount +parseInt(monthDues));
      }
      if(messDues)
      {
        this.totalAmount= Number(this.totalAmount +parseInt(messDues));
      }
      if(this.lateFee)
      {
        this.totalAmount= Number(this.totalAmount +this.lateFee);
      }
      
        if(Number(this.totalAmount)>0)
        { this.totalDisabled=false;

        }
        else{
          this.totalDisabled=true;
        }

      this.form.updateValueAndValidity()

      this.form.controls.totalAmount.setValue(this.totalAmount);
      this.form.controls.totalAmount.updateValueAndValidity();


    }
    hideError(controlName:any)
    {
      this.form.controls[controlName].markAsUntouched();
      if(this.submitBtnMsgClass && this.submitBtnMsgClass.indexOf("alertBlock")>-1)
      {  this.submitBtnMsgClass="wrapper"; }
      if(this.submitBtnMsg && this.submitBtnMsg.indexOf("a")>-1)
      { this.submitBtnMsg=""; }

    }
}
